/* eslint-disable no-unused-vars */
import React, { Component } from 'react';

const GetTime = () => {
  const dateVariable = new Date();
  dateVariable.getTime();
  return dateVariable;
};

export default GetTime;